module.exports = __webpack_public_path__ + "img/cancelar.293d0c86.png";